import { useNavigate } from 'react-router-dom';
import PublicNavbar from '../components/PublicNavbar';

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />

      <div className="max-w-4xl mx-auto px-6 pt-28 pb-12 sm:pt-36 sm:pb-20">
        <div className="prose prose-lg max-w-none">
          <h2 className="text-4xl font-black text-[#1B4332] mb-6" style={{ fontFamily: 'Nunito, sans-serif' }}>Refund Policy</h2>
          <p className="text-[#1B4332]/80 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>7-Day Money-Back Guarantee</h3>
            <p className="text-[#1B4332]/80 mb-4">
              We stand behind the quality of PurrCheck. If you're a first-time Premium subscriber and are not satisfied with our service, 
              we offer a <strong>7-day money-back guarantee</strong> from the date of your initial Premium subscription purchase.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Eligibility</h3>
            <p className="text-[#1B4332]/80 mb-4">To be eligible for a refund:</p>
            <ul className="list-disc pl-6 text-[#1B4332]/80 space-y-2">
              <li>You must be a <strong>first-time</strong> Premium subscriber</li>
              <li>You must request the refund within <strong>7 days</strong> of your initial Premium subscription purchase</li>
              <li>This applies to both monthly ($8.99) and yearly ($79.99) Premium plans</li>
              <li>You must contact support at <a href="mailto:support@purrcheck.com" className="text-primary hover:underline">support@purrcheck.com</a></li>
            </ul>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>No Refund After 7 Days</h3>
            <p className="text-[#1B4332]/80 mb-4">
              After the 7-day guarantee period has passed, <strong>no refunds will be issued</strong> for:
            </p>
            <ul className="list-disc pl-6 text-[#1B4332]/80 space-y-2">
              <li>Partial months or years of subscription</li>
              <li>Renewals (monthly or annual)</li>
              <li>Unused scans or chat questions</li>
              <li>Accounts that have been closed or banned for Terms of Service violations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>How to Request a Refund</h3>
            <p className="text-[#1B4332]/80 mb-4">To request a refund within the 7-day guarantee period:</p>
            <ol className="list-decimal pl-6 text-[#1B4332]/80 space-y-2">
              <li>Email us at <a href="mailto:support@purrcheck.com" className="text-primary hover:underline">support@purrcheck.com</a></li>
              <li>Include your account email address</li>
              <li>State that you're requesting a refund under the 7-day guarantee</li>
              <li>Allow 5-7 business days for processing</li>
            </ol>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Refund Processing</h3>
            <p className="text-[#1B4332]/80 mb-4">
              Approved refunds will be processed within 5-7 business days and will be credited back to the original payment method. 
              You will receive a confirmation email once the refund has been processed.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Subscription Cancellation</h3>
            <p className="text-[#1B4332]/80 mb-4">
              If you wish to cancel your subscription without requesting a refund, you can do so at any time from your account settings. 
              You will retain Premium access until the end of your current billing period.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Free Plan</h3>
            <p className="text-[#1B4332]/80 mb-4">
              The Free plan requires no payment and therefore has no refund policy. You can use the Free plan indefinitely at no cost.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Contact Us</h3>
            <p className="text-[#1B4332]/80 mb-4">
              If you have any questions about our refund policy, please contact our support team:
            </p>
            <p className="text-[#1B4332]/80">
              <strong>Email:</strong> <a href="mailto:support@purrcheck.com" className="text-primary hover:underline">support@purrcheck.com</a><br />
              <strong>Response Time:</strong> Within 24-48 hours
            </p>
          </section>

          <div className="bg-[#BFDB38]/10 border-2 border-[#BFDB38]/30 rounded-2xl p-6">
            <p className="text-[#1B4332] font-bold mb-2">Try Risk-Free!</p>
            <p className="text-[#1B4332]/80">
              We're confident you'll love PurrCheck Premium. With our 7-day money-back guarantee, 
              you can try all Premium features risk-free and see the difference it makes for your cat's health!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;